const successEmail = function(email, reference) {
  const APIKEY = "928fc5d6-5f8b-4952-bcd9-45e94a219d9e";
  const subject = "Success Your Application at DSA";
  const sender = "noreply@dsaportal.gov.ng";
  const bodyText = `Your job application to Defence Space Administration have successfully been submitted.
  Reference number: ${reference}.`;
  const opts = {
    method: "POST"
  };
  return fetch(
    `https://api.elasticemail.com/v2/email/send?apikey=${APIKEY}&subject=${subject}&from=${sender}&msgTo=${email}&bodyText=${bodyText}&isTransactional=true`,
    opts
  );
};

export default successEmail;



// WEBPACK FOOTER //
// ./src/utils/successEmail.js